import axiosInstance from "./api";

const reviewApi = {
  createReview: (payload) => axiosInstance.post("/reviews", payload),

  getMyReviewForEvent: async ({ eventId, reviewerId, revieweeId }) => {
    const response = await axiosInstance.get("/reviews", {
      params: {
        eventId,
        reviewerId,
        revieweeId,
      },
    });

    const data = response?.data;
    if (Array.isArray(data)) return data[0] || null;
    if (Array.isArray(data?.reviews)) return data.reviews[0] || null;
    if (Array.isArray(data?.data)) return data.data[0] || null;
    if (data?.review) return data.review;
    if (data?.data && !Array.isArray(data.data)) return data.data;
    return null;
  },
};

export default reviewApi;
